import { useSelector } from "react-redux"
import Banner from "@/component/banner"
import BannerForm from "@/component/form/bannerForm"

import styles from "./index.module.less"
import { classModuleGenerator } from "@/utils"

import Environment from "@/pages/home/components/environment"
import Campus from "@/pages/home/components/campus"

function Index() {
  const classnames = classModuleGenerator(styles)
  const { photos } = useSelector((state) => state.page)
  const banners = [
    {
      imageUrl: require("@/assets/images/yikao-banner.png"),
      intro: "因材施教，短期逆袭让艺考更“易”考",
      name: "定制化教学/阶梯式进步",
      _id: "yikao",
    },
  ]

  const superioritys = [
    {
      name: "懂艺考",
      intro: "艺考政策、数据解析、央美清美、喜报连连",
    },
    {
      name: "懂高考",
      intro: "考试系统、学情系统、真题汇编、资深专业",
    },
    {
      name: "懂教学",
      intro: "定期教研、严格把关、学刊编审、实力硬核",
    },
    {
      name: "懂学生",
      intro: "个性辅导、心理疏导、教学教务、多方关注",
    },
    {
      name: "懂家长",
      intro: "沟通学情、实时反馈、院校专业、规划明确",
    },
    {
      name: "懂教育",
      intro: "升学指导、层层服务、思想德育、综合培养",
    },
  ]
  return (
    <div className="home">
      <Banner banners={banners}>
        <BannerForm
          classname="yikao"
          name="免费获取文化课专属辅导方案"
          title="因材施教，短期逆袭让艺考更“易”考"
          stitle="定制化教学/阶梯式进步"
        />
      </Banner>
      <section className={classnames("manage-container")}>
        <h3 className="section__title">教育管理</h3>
        <div className="section__inner">
          <ul className={classnames("manage-wrap")}>
            <li>
              <div className={classnames("manage-poster")}></div>
              <h4>艺考生的特点</h4>
            </li>
            <li className={classnames("manage-middle")}>
              <div className={classnames("manage-inner")}>
                <h4>家长的期望</h4>
                <p>
                  能在短时间内取得文化课成绩的进步；培养学生良好的行为习惯和学习习
                </p>
              </div>
            </li>
            <li>
              <div className={classnames("manage-poster")}></div>
              <h4>学大的落实</h4>
            </li>
          </ul>
        </div>
      </section>

      <section className={classnames("teachfeatures-container")}>
        <h3 className="section__title">教学特点</h3>
        <div className="section__inner">
          <div className={classnames("teachfeatures-inner")}>
            <ul>
              <li>
                <h5>量身定制，专属教材</h5>
                <p>
                  根据艺考生文化课基础薄弱的特点，量身定制专属教材，理清基础知识脉络，浓缩高考高频考点，夯实基础，短期逆袭！
                </p>
              </li>
              <li>
                <h5>互动教学，主次分明</h5>
                <p>
                  灵活互动的教学方法，让学生快速掌握学习知识，举一反三；根据高三学生不同的时间节点，科学规划一二三轮学习内容，查漏补缺，主次分明。
                </p>
              </li>
              <li>
                <h5>课后巩固，强抓落实</h5>
                <p>
                  专属班主任统一管理，每日记录学生每日考勤表，作业记录表，学生笔记、纠错检查表，早读任务检查表等，狠抓落实，保证教学效果。
                </p>
              </li>
              <li>
                <h5>封闭管理，家校互动</h5>
                <p>
                  学生的学习、生活实行统一封闭管理，专属班主任定期向家长反馈学生在校的学习情况
                </p>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className={classnames("superiority-container")}>
        <h3 className="section__title">六大核心优势</h3>
        <div className="section__inner">
          <div className={classnames("superiority-inner")}>
            <ul className="clearfix">
              {superioritys.map((m) => (
                <li key={m.name}>
                  <h5>{m.name}</h5>
                  <p>{m.intro}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
      <section className={classnames("teachers-container")}>
        <h3 className="section__title">学大全日制实力师资团队</h3>
        <div className="section__inner">
          <div className={classnames("teachers-wrap")}>
            <div className={classnames("teachers-left")}></div>
            <div className={classnames("teachers-right")}></div>
          </div>
        </div>
      </section>
      <section className={classnames("material-container")}>
        <h3 className="section__title">学大艺考全日制专属教材</h3>
        <div className="section__inner">
          <div className={classnames("material-wrap")}>
            <div className={classnames("material-intro")}>
              <h4>定制辅导方案 配套校本教材</h4>
              <ul>
                <li>根据艺考生特点，将各科知识点，化难为易删繁就简</li>
                <li>
                  梳理知识架构、进行归纳分类，一、二、三轮复习主次分明，查漏补缺
                </li>
                <li>
                  所学知识和配套校本试题练习相结合，海量题库以供选择，学以致用、活学活用
                </li>
                <li>
                  对常考知识点、高频考点、重点、难点、易错点分类整理，系统化梳理知识结构，助力学生轻松掌握
                </li>
              </ul>
            </div>
            <ul className={classnames("material-content")}>
              {[1, 2, 3, 4, 5, 6, 7, 8].map((m) => (
                <li
                  key={m}
                  style={{
                    background: `url(${require("@/assets/images/material-demo" +
                      m +
                      ".png")}) no-repeat center/cover `,
                  }}
                ></li>
              ))}
            </ul>
          </div>
        </div>
      </section>
      <Environment photos={photos} />
      <Campus />
    </div>
  )
}

export default Index